import React, { FC } from 'react'

type Props = {
  desktopAvatar: any
  desktopChart: any
  mobileAvatar: any
  mobileChart: any
}

export const Columns: FC<Props> = ({ desktopAvatar, desktopChart, mobileAvatar, mobileChart }) => {
  const desktopOne = (
    <div className="desktopWrapper">
      {desktopAvatar?.imageOne && (
        <img
          src={desktopAvatar.imageOne}
          alt={desktopAvatar.imageOneAlt}
          width={348}
          height={296}
        />
      )}

      {desktopChart?.imageOne && (
        <img src={desktopChart.imageOne} alt={desktopChart.imageOneAlt} width={259} height={835} />
      )}
    </div>
  )

  const mobileOne = (
    <div className="mobileWrapper">
      {mobileAvatar?.imageOne && (
        <img src={mobileAvatar.imageOne} alt={mobileAvatar.imageOneAlt} width={156} height={276} />
      )}

      {mobileChart?.imageOne && (
        <img src={mobileChart.imageOne} alt={mobileChart.imageOneAlt} width={296} height={835} />
      )}
    </div>
  )

  const desktopTwo = (
    <div className="desktopWrapper">
      {desktopAvatar?.imageTwo && (
        <img
          src={desktopAvatar.imageTwo}
          alt={desktopAvatar.imageTwoAlt}
          width={348}
          height={305}
        />
      )}

      {desktopChart?.imageTwo && (
        <img src={desktopChart.imageTwo} alt={desktopChart.imageTwoAlt} width={318} height={551} />
      )}
    </div>
  )

  const mobileTwo = (
    <div className="mobileWrapper">
      {mobileAvatar?.imageTwo && (
        <img src={mobileAvatar.imageTwo} alt={mobileAvatar.imageTwoAlt} width={313} height={212} />
      )}

      {mobileChart?.imageTwo && (
        <img src={mobileChart.imageTwo} alt={mobileChart.imageTwoAlt} width={328} height={551} />
      )}
    </div>
  )

  return (
    <div className="CollapsibleQuadrant__Columns">
      <div className="CollapsibleQuadrant__Column-One">
        {desktopOne}
        {mobileOne}
      </div>

      <div className="CollapsibleQuadrant__Column-Two">
        {desktopTwo}
        {mobileTwo}
      </div>
    </div>
  )
}
